module.exports = __webpack_public_path__ + "public/img/fix3.eb8ec11d.jpg";